<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb :breadcrumb="[
                { title: 'Community', url: app_url, status: false },
                { title: 'News', url: app_url+'/news', status: true }
            ]"></breadcrumb>
            <section id="all-news" class="section withPad">
                <div class="container">
                    <div class="row-grid">
                        <div class="col-grid-60">
                            <div class="list_all_news">
                                <div class="all_news_tabs_menu">
                                    <a @click="changeTab('all', 'Semua')"
                                        class="news_tabs_menu news_trigger_tabs "
                                        :class="{active : currentTab == 'all'}">Semua</a>
                                    <a @click="changeTab('tips', 'Tips')"
                                        class="news_tabs_menu news_trigger_tabs "
                                        :class="{ active: currentTab == 'tips'}">Tips</a>
                                    <a @click="changeTab('sosok-brader', 'Sosok Brader')"
                                        class="news_tabs_menu news_trigger_tabs "
                                        :class="{active : currentTab == 'sosok-brader'}">Sosok Brader</a>
                                </div>
                                <div class="all_news_tabs_content">
                                    <div id="all" class="tab_isi_news" :class="{hide : currentTab != 'all'}">
                                        <AllNewsSectionTab :endpoint="api_url+'/news'" newsSection="Semua"></AllNewsSectionTab>
                                    </div>

                                    <div id="News" class="tab_isi_news" :class="{hide : currentTab != 'tips'}">
                                        <AllVerticalNews :endpoint="api_url+'/news-tips'" newsSection="Tips"></AllVerticalNews>
                                    </div>
                                    <div id="sosokbrader" class="tab_isi_news"
                                        :class="{hide : currentTab != 'sosok-brader'}">
                                        <AllVerticalNews :endpoint="api_url+'/news-brader?data=all'" newsSection="Sosok Brader"></AllVerticalNews>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-grid-40">
                            <SosokBrader></SosokBrader>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import NewsCard from "../news/NewsCard";
import EventCard from "../../widget/EventCard";
import SosokBrader from "../news/SosokBrader";
import AllVerticalNews from "../news/AllVerticalNews";
import AllNewsSectionTab from "../news/AllNewsSectionTab";
import { isMobile } from "mobile-device-detect";
import $ from 'jquery';

export default {
    components: {
        breadcrumb: BreadCrumb,
        NewsCard,
        SosokBrader,
        AllVerticalNews,
        AllNewsSectionTab,
        EventCard
    },
    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            show: false,
            mobile: false,
            tlength: 25,
            currentTab:'all',
        };
    },
    created() {
        this.mobile = isMobile;
        if(this.getParam('news')){
         this.currentTab = this.getParam('news');
        //  console.log(this.getParam('news'));
        }else{
          this.pushParams('news','all')
        }
    },
    methods: {
        showShare() {
            this.show = !this.show;
            // console.log(this.show);
        },
        changeTab(target, title){
            var dataTracker = {
                'event': 'filterTracking',
                'eventDetail.category': 'Filter Tracking',
                'eventDetail.action': 'Content Type',//or Semua, Pilih Brand
                'eventDetail.label': title,//or  Harga Tertinggi, Harga Terendah, Honda Beat, Honda Genio, etc
                'filterType': 'News'// or Oli, Motor, Price
            }
            dataLayer.push(dataTracker);
            // console.log(dataTracker);
            this.currentTab = target;
             this.pushParams('news',target)
        },
        insertParam(key, value) {
            var uri = window.location.href;
            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
            }
            else {
            return uri + separator + key + "=" + value;
            }
        },
        pushParams(key, value){
            var newUrl =this.insertParam(key,value);
            window.history.pushState("", value, newUrl);
        },
        getParam(param) {
        var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i=0;i<url.length;i++) {
            var params = url[i].split("=");
            if(params[0] == param)
                return params[1];
        }
        return false;
        },
    },
};
</script>

<style scoped lang="scss">
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    margin-top: 15px;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
</style>
